import WhatsappNew from "@/components/integration-modals/Whatsapp";
import useWhatsAppConfig from "@/pages/omni-builder/react-query/configs/useWhatsAppConfig";
import { useState } from "react";
import { motion } from "framer-motion";
import {
  OutgrowWhatsAppChannelBanner,
  WhatsAppChannelBanner,
} from "@/assets/socialImages/WhatsAppChannelBanner";
import { useSelector } from "react-redux";
import { State } from "@/redux/Types";

interface Props {
  onClose?: any;
  botCustomId?: any;
  liveBotId?: any;
  // fromBuilder?: any;
  // getHandoffConfigs?: any;
  onSelect?: any;
}

const WhatsappFormSkeleton = () => (
  <div className="mt-[10px]">
    <div className="mb-[10px] h-[16px] w-[160px] animate-pulse rounded-[4px] bg-[#e8e8e8]" />

    <div className="rounded-[20px] bg-[#fafafa] p-[20px]">
      <div className="mb-[10px] flex flex-col gap-[10px]">
        <div className="h-[14px] w-[100px] animate-pulse rounded-[4px] bg-[#e0e0e0]" />
        <div className="flex w-full items-center justify-between gap-[10px] rounded-[10px] border border-[rgba(0,0,0,0.10)] bg-[#fff] p-[15px]">
          <div className="flex items-center gap-[8px]">
            <div className="h-[20px] w-[20px] animate-pulse rounded-full bg-[#e0e0e0]" />
            <div className="h-[16px] w-[120px] animate-pulse rounded-[4px] bg-[#e8e8e8]" />
          </div>
          <div className="h-[24px] w-[24px] animate-pulse rounded-[6px] bg-[#FFEDEE]" />
        </div>
      </div>

      <div className="mb-[10px] h-[14px] w-[50px] animate-pulse rounded-[4px] bg-[#e0e0e0]" />

      <div className="overflow-hidden rounded-[10px] border border-[rgba(0,0,0,0.10)]">
        <div
          className="grid bg-gray-100"
          style={{
            gridTemplateColumns: "220px 250px 150px minmax(210px, 1fr)",
          }}
        >
          {["Name", "Phone Number", "Status", "Action"].map((col) => (
            <div key={col} className="px-[20px] py-[13px]">
              <div className="h-[14px] w-[70%] animate-pulse rounded-[4px] bg-[#d8d8d8]" />
            </div>
          ))}
        </div>
        {[0, 1].map((row) => (
          <div
            key={row}
            className="grid border-b border-b-[rgba(0,0,0,0.05)]"
            style={{
              gridTemplateColumns: "220px 250px 150px minmax(210px, 1fr)",
            }}
          >
            <div className="flex items-center gap-[8px] px-[20px] py-[13px]">
              <div className="h-[14px] w-[80px] animate-pulse rounded-[4px] bg-[#e8e8e8]" />
              <div className="h-[20px] w-[55px] animate-pulse rounded-[5px] bg-[#e0e0e0]" />
            </div>
            <div className="flex items-center px-[20px] py-[13px]">
              <div className="h-[14px] w-[130px] animate-pulse rounded-[4px] bg-[#e8e8e8]" />
            </div>
            <div className="flex items-center px-[20px] py-[13px]">
              <div className="h-[24px] w-[70px] animate-pulse rounded-full bg-[#e8e8e8]" />
            </div>
            <div className="flex items-center px-[20px] py-[13px]">
              <div className="h-[30px] w-[110px] animate-pulse rounded-[10px] bg-[#e8e8e8]" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const WhatsappChannel = ({ botCustomId, liveBotId }: Props) => {
  const whatsappConfiguration = useWhatsAppConfig();
  const fromOutgrow = useSelector((state: State) => state.user.fromOutgrow);
  const [openPopUp, setOpenPopUp] = useState(false);

  const handleClose = () => {
    console.log("not required here...");
  };
  const isLoading = whatsappConfiguration.isLoading;
  return (
    <motion.div
      className="external-channels"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.4,
        ease: [0.42, 0, 0.58, 1],
      }}
    >
      <div className="flex flex-col gap-[10px]">
        <h3 className="text-[14px] font-medium leading-[110%] max-[1280px]:!text-[13px]">
          Whatsapp Settings
        </h3>
        <div className="embed_outer relative rounded-[20px] bg-[#fafafa] p-[20px]">
          {fromOutgrow ? (
            <OutgrowWhatsAppChannelBanner />
          ) : (
            <WhatsAppChannelBanner />
          )}
          {isLoading ? (
            <div className="absolute bottom-[50px] left-[50px] h-[34px] w-[160px] animate-pulse rounded-[100px] bg-[#e0e0e0]" />
          ) : !whatsappConfiguration?.data ? (
            <a
              onClick={() => {
                setOpenPopUp(true);
              }}
              className="absolute bottom-[50px] left-[50px] cursor-pointer"
            >
              <img
                className="rounded-[100px]"
                src="https://dlvkyia8i4zmz.cloudfront.net/FyKuewvVR0GjRQp2cDyo_Frame_1618874797.svg"
                alt="login with facebook"
                loading="lazy"
              />
            </a>
          ) : (
            <p className="absolute bottom-[50px] left-[50px] flex gap-1 rounded-full bg-[#DAF1DD] px-[6px] py-[5px] text-[12px] leading-[110%] text-[#25612c]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={12}
                height={12}
                viewBox="0 0 12 12"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6 0C9.31371 1.93283e-07 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 1.9333e-07 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM9.38576 3.3325C9.17319 3.32541 8.9665 3.40295 8.81101 3.54806L7.55431 4.72442C7.5279 4.74334 7.50267 4.76387 7.47874 4.78585L4.8 7.28977L3.10865 5.48032C2.96382 5.32453 2.76309 5.23257 2.55052 5.22459C2.33795 5.21662 2.13089 5.29331 1.97479 5.43782C1.81965 5.5833 1.72853 5.78437 1.72144 5.99693C1.71436 6.20949 1.79189 6.41619 1.937 6.57168L4.1244 8.92916L4.12912 8.91971L4.71968 9.55277L6.05667 8.31026L9.90708 4.7197C10.0622 4.57423 10.1533 4.37315 10.1604 4.16059C10.1675 3.94803 10.09 3.74133 9.94487 3.58585C9.79939 3.4307 9.59832 3.33958 9.38576 3.3325Z"
                  fill="#25612C"
                />
              </svg>
              Connected
            </p>
          )}
        </div>

        {isLoading ? (
          <WhatsappFormSkeleton />
        ) : !!whatsappConfiguration?.data || openPopUp ? (
          <WhatsappNew
            onClose={handleClose}
            botCustomId={botCustomId}
            liveBotId={liveBotId}
            setOpenPopUp={setOpenPopUp}
          />
        ) : null}
      </div>
    </motion.div>
  );
};

export default WhatsappChannel;

export const DisconnectIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={14}
    viewBox="0 0 15 14"
    fill="none"
  >
    <g clipPath="url(#clip0_5565_24784)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.57909 1.47953H13.3165V1.46094H13.9709C14.1425 1.46094 14.3071 1.52929 14.4284 1.65063C14.5498 1.77198 14.6179 1.9366 14.6179 2.10819C14.6179 2.27974 14.5497 2.4442 14.4284 2.56551C14.3071 2.68686 14.1425 2.75521 13.9709 2.75521H13.3239V4.69626C13.3239 7.68821 11.0553 10.1605 8.14749 10.4834V11.8139C8.14748 11.9855 8.07936 12.1501 7.95803 12.2715C7.83671 12.3928 7.67205 12.4609 7.50047 12.4609C7.32889 12.4609 7.16426 12.3928 7.04291 12.2715C6.92158 12.1501 6.85347 11.9855 6.85346 11.8139V10.4834C3.9456 10.1605 1.67685 7.68823 1.67685 4.69626V2.75521H1.02983C0.858233 2.7552 0.693608 2.68685 0.57227 2.56551C0.451002 2.4442 0.382839 2.27972 0.382812 2.10819C0.382813 1.93662 0.450967 1.77197 0.57227 1.65063C0.693608 1.5293 0.858233 1.46095 1.02983 1.46094H2.57909V1.47953ZM2.97112 2.75521V4.69626C2.97112 7.19388 5.0035 9.22562 7.50047 9.22562C9.99741 9.22557 12.0298 7.19386 12.0298 4.69626V2.75521H2.97112Z"
        fill="#FB5F66"
      />
    </g>
    <defs>
      <clipPath id="clip0_5565_24784">
        <rect
          width={14}
          height={14}
          fill="white"
          transform="translate(0.333008)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ConnectIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={14}
    viewBox="0 0 15 14"
    fill="none"
  >
    <g clipPath="url(#clip0_5565_491)">
      <path
        d="M13.166 4.08333H10.2493V0.583333C10.2493 0.428624 10.1879 0.280251 10.0785 0.170854C9.9691 0.0614582 9.82073 0 9.66602 0C9.51131 0 9.36293 0.0614582 9.25354 0.170854C9.14414 0.280251 9.08268 0.428624 9.08268 0.583333V4.08333H5.58268V0.583333C5.58268 0.428624 5.52122 0.280251 5.41183 0.170854C5.30243 0.0614582 5.15406 0 4.99935 0C4.84464 0 4.69627 0.0614582 4.58687 0.170854C4.47747 0.280251 4.41602 0.428624 4.41602 0.583333V4.08333H1.49935C1.34464 4.08333 1.19627 4.14479 1.08687 4.25419C0.977474 4.36358 0.916016 4.51196 0.916016 4.66667C0.916016 4.82138 0.977474 4.96975 1.08687 5.07915C1.19627 5.18854 1.34464 5.25 1.49935 5.25H2.08268V7C2.08268 9.69733 4.12785 11.9262 6.74935 12.2173V13.4167C6.74935 13.5714 6.81081 13.7197 6.9202 13.8291C7.0296 13.9385 7.17797 14 7.33268 14C7.48739 14 7.63577 13.9385 7.74516 13.8291C7.85456 13.7197 7.91602 13.5714 7.91602 13.4167V12.2173C10.5375 11.9262 12.5827 9.69733 12.5827 7V5.25H13.166C13.3207 5.25 13.4691 5.18854 13.5785 5.07915C13.6879 4.96975 13.7493 4.82138 13.7493 4.66667C13.7493 4.51196 13.6879 4.36358 13.5785 4.25419C13.4691 4.14479 13.3207 4.08333 13.166 4.08333ZM11.416 7C11.416 9.25167 9.58377 11.0833 7.33268 11.0833C5.0816 11.0833 3.24935 9.25167 3.24935 7V5.25H11.416V7Z"
        fill="#666666"
      />
    </g>
    <defs>
      <clipPath id="clip0_5565_491">
        <rect
          width={14}
          height={14}
          fill="white"
          transform="translate(0.333008)"
        />
      </clipPath>
    </defs>
  </svg>
);
